import React from 'react';
import TicTacToe from './TicTacToe';
import MemoryMatch from './MemoryMatch';

/**
 * WellnessGamesPage component
 * Dedicated page for wellness games that is shown when users click on the mobile collapsible card
 */
const WellnessGamesPage = ({ onBack }) => {
  return (
    <div className="wellness-games-page">
      {/* Header with back button */}
      <div className="d-flex align-items-center mb-4">
        <button 
          className="btn btn-sm btn-light me-3" 
          onClick={onBack}
          style={{ 
            borderRadius: '50%', 
            width: '36px', 
            height: '36px', 
            padding: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <i className="fas fa-arrow-left"></i>
        </button>
        <h5 className="mb-0">Wellness Games</h5>
      </div>

      {/* Description */}
      <p className="text-muted mb-4">
        These mindful activities can help you relax and pass the time while waiting for your appointment.
      </p>

      {/* Games */}
      <div className="row">
        <div className="col-12 mb-4">
          <TicTacToe />
        </div>
        <div className="col-12">
          <MemoryMatch />
        </div>
      </div>
    </div>
  );
};

export default WellnessGamesPage;
